var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center",attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_c('span',{staticClass:"text-sm md:text-base"},[_vm._v(" "+_vm._s(_vm.custom_caption)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }